module.exports = __webpack_public_path__ + "assets/img/tit1.bca41d8c.png";